export enum LogTabEnum {
  Application = 'Application',
  Consumer = 'Consumer',
  Event = 'Event',
}
